/*
 * Fix específico para Globo Filter en páginas de colección
 * Asegura que Globo inicialice correctamente con el tema actual
 */

(function() {
  'use strict';
  
  console.log('🎯 Inicializando fix específico para Globo Filter...');
  
  // === CONFIGURACIÓN ===
  const GLOBO_CONFIG = {
    selectors: {
      productGrid: '.ProductList, .ProductListWrapper',
      products: '.Grid__Cell, .ProductItem',
      filters: '[class*="filter"], [data-filter]',
      pagination: '.Pagination, [class*="pagination"]'
    },
    timeouts: {
      domReady: 1000,
      windowLoad: 2000,
      fallback: 5000
    }
  };
  
  // === FUNCIONES HELPER ===
  
  function isCollectionPage() {
    return document.body.classList.contains('is-collection-page') ||
           window.location.pathname.includes('/collections/') ||
           document.querySelector('.CollectionMain');
  }
  
  function findGloboElements() {
    return {
      productGrid: document.querySelector(GLOBO_CONFIG.selectors.productGrid),
      products: document.querySelectorAll(GLOBO_CONFIG.selectors.products),
      scripts: document.querySelectorAll('script[src*="globo"], script[data-cfasync]'),
      inlineScripts: Array.from(document.querySelectorAll('script')).filter(s => 
        s.textContent && (s.textContent.includes('globo') || s.textContent.includes('gspf'))
      )
    };
  }
  
  function diagnoseGloboIssues() {
    const elements = findGloboElements();
    
    console.group('🔍 Diagnóstico de Globo Filter');
    console.log('Página de colección:', isCollectionPage() ? '✅' : '❌');
    console.log('Grid de productos:', elements.productGrid ? '✅' : '❌');
    console.log('Productos encontrados:', elements.products.length);
    console.log('Scripts externos:', elements.scripts.length);
    console.log('Scripts inline:', elements.inlineScripts.length);
    console.log('window.Globo:', window.Globo ? '✅' : '❌');
    
    if (elements.productGrid) {
      console.log('Grid selector actual:', elements.productGrid.className);
      console.log('Grid ID:', elements.productGrid.id || 'sin ID');
    }
    
    console.groupEnd();
    
    return elements;
  }
  
  function forceGloboInitialization() {
    const elements = findGloboElements();
    
    // Intentar múltiples métodos de inicialización
    const initMethods = [
      // Método 1: API directa de Globo
      () => {
        if (window.Globo && window.Globo.filter) {
          if (typeof window.Globo.filter.init === 'function') {
            window.Globo.filter.init();
            console.log('✅ Globo inicializado via API directa');
            return true;
          }
          if (typeof window.Globo.filter.refresh === 'function') {
            window.Globo.filter.refresh();
            console.log('✅ Globo refrescado via API');
            return true;
          }
        }
        return false;
      },
      
      // Método 2: Trigger de eventos DOM
      () => {
        if (elements.productGrid) {
          const event = new Event('DOMContentLoaded', { bubbles: true });
          elements.productGrid.dispatchEvent(event);
          console.log('✅ Evento DOMContentLoaded triggereado en grid');
          return true;
        }
        return false;
      },
      
      // Método 3: Forzar re-evaluación de scripts inline
      () => {
        elements.inlineScripts.forEach((script, index) => {
          if (script.textContent.includes('gspf') || script.textContent.includes('globo')) {
            try {
              // Re-ejecutar script de configuración
              const configMatch = script.textContent.match(/window\.gspfSettings\s*=\s*({[^}]+})/);
              if (configMatch) {
                eval(configMatch[0]);
                console.log(`✅ Configuración Globo re-ejecutada (script ${index + 1})`);
                return true;
              }
            } catch (e) {
              console.warn(`⚠️ Error re-ejecutando script ${index + 1}:`, e);
            }
          }
        });
        return false;
      },
      
      // Método 4: Crear observer para productos nuevos
      () => {
        if (elements.productGrid && window.MutationObserver) {
          const observer = new MutationObserver(() => {
            if (window.Globo && window.Globo.filter && typeof window.Globo.filter.init === 'function') {
              window.Globo.filter.init();
              console.log('✅ Globo re-inicializado por MutationObserver');
            }
          });
          
          observer.observe(elements.productGrid, {
            childList: true,
            subtree: true
          });
          
          console.log('✅ Observer configurado para cambios en grid');
          return true;
        }
        return false;
      }
    ];
    
    // Ejecutar métodos de inicialización
    let successCount = 0;
    initMethods.forEach((method, index) => {
      try {
        if (method()) {
          successCount++;
        }
      } catch (e) {
        console.warn(`⚠️ Error en método de inicialización ${index + 1}:`, e);
      }
    });
    
    return successCount > 0;
  }
  
  function checkGloboWorking() {
    setTimeout(() => {
      const elements = findGloboElements();
      const isWorking = elements.productGrid && 
                       (window.Globo || elements.scripts.length > 0) &&
                       elements.products.length > 0;
      
      if (isWorking) {
        console.log('🎉 Globo Filter parece estar funcionando correctamente');
      } else {
        console.group('❌ Globo Filter no está funcionando');
        console.log('Posibles causas:');
        console.log('  - App Globo no está instalada o activada');
        console.log('  - Configuración incorrecta en admin de Globo');
        console.log('  - Conflicto con otras apps o scripts');
        console.log('  - Selector de grid incorrecto');
        console.groupEnd();
        
        // Intentar diagnóstico adicional
        setTimeout(() => {
          console.log('🔧 Intentando fix adicional...');
          forceGloboInitialization();
        }, 2000);
      }
    }, 3000);
  }
  
  // === INICIALIZACIÓN PRINCIPAL ===
  
  function initGloboFix() {
    if (!isCollectionPage()) {
      console.log('ℹ️ No es página de colección, saltando fix de Globo');
      return;
    }
    
    console.log('🎯 Página de colección detectada, aplicando fix de Globo...');
    
    // Diagnóstico inmediato
    diagnoseGloboIssues();
    
    // Intentar inicialización en múltiples momentos
    const timeouts = GLOBO_CONFIG.timeouts;
    
    // Intento 1: DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
          console.log('🔄 Intento 1: DOM Ready');
          forceGloboInitialization();
        }, timeouts.domReady);
      });
    } else {
      setTimeout(() => {
        console.log('🔄 Intento 1: DOM Already Ready');
        forceGloboInitialization();
      }, timeouts.domReady);
    }
    
    // Intento 2: Window load
    window.addEventListener('load', () => {
      setTimeout(() => {
        console.log('🔄 Intento 2: Window Load');
        forceGloboInitialization();
      }, timeouts.windowLoad);
    });
    
    // Intento 3: Fallback
    setTimeout(() => {
      console.log('🔄 Intento 3: Fallback');
      if (!window.Globo || !window.Globo.filter) {
        console.warn('⚠️ Globo aún no está disponible, último intento...');
        forceGloboInitialization();
      }
    }, timeouts.fallback);
    
    // Check final
    checkGloboWorking();
  }
  
  // === HELPER PARA DEBUGGING ===
  
  window.debugGlobo = function() {
    console.log('🔧 Debug manual de Globo Filter');
    diagnoseGloboIssues();
    forceGloboInitialization();
    
    // Test de funcionamiento
    setTimeout(() => {
      const filterElements = document.querySelectorAll('[class*="filter"], [data-filter]');
      console.log('Elementos de filtro encontrados:', filterElements.length);
      
      if (filterElements.length > 0) {
        console.log('✅ Elementos de filtro presentes');
        filterElements.forEach((el, i) => {
          console.log(`Filter ${i + 1}:`, el.className);
        });
      } else {
        console.warn('❌ No se encontraron elementos de filtro');
      }
    }, 1000);
  };
  
  // Inicializar
  initGloboFix();
  
  console.log('💡 Para debugging manual, ejecuta: debugGlobo()');
  
})();
